import { FaRegComment, FaPaperPlane } from 'react-icons/fa';
import Comment from './Comment';
import React, { useState, useEffect } from 'react';
import { api } from '../services/api';
import { useLocation } from 'react-router-dom';

function FeedCardFooter({ review, updateReview, user, onLogin }) {
  const [newComment, setNewComment] = useState('');
  const [expandedComments, setExpandedComments] = useState({});
  const [showComments, setShowComments] = useState(false);
  const location = useLocation();
  function findPathToComment(comments, targetId, path = []) {
    for (const comment of comments) {
      const newPath = [...path, comment.id];
      if (comment.id === parseInt(targetId)) {
        return newPath;
      }
      if (comment.nestedComments && comment.nestedComments.length) {
        const childPath = findPathToComment(comment.nestedComments, targetId, newPath);
        if (childPath) return childPath;
      }
    }
    return null;
  }
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const surgeryParam = searchParams.get('surgery');
    const commentParam = searchParams.get('comment')
    if (surgeryParam == review.id && review.comments?.length) {
      const path = findPathToComment(review.comments, commentParam)
      if (path) {
        setShowComments(true)
        path.forEach(key => {
          expandedComments[key] = true
        })
        setExpandedComments({ ...expandedComments })
        setTimeout(() => {
          const el = document.getElementById(`comment-wrapper-${commentParam}`);
          if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'start' });
            el.classList.add('temp-highlight');
        
            setTimeout(() => {
              el.classList.remove('temp-highlight');
            }, 3000);
          }
        }, 300);
      }
    }
  }, [location.search])
  const toggleComment = () => {
    setShowComments(!showComments)
  }
  const handleSubmitComment = async (text, commentId) => {

    // Check if user is logged in
    if (!user) {
      onLogin();
      return;
    }

    try {
      await api.createComment({
        reviewId: parseInt(review.id),
        text,
        commentId
      });
      setNewComment('')
      api.getComments(review.id)
        .then(res => {
          updateReview({ ...review, comments: res })
        })
    } catch (err) {
      if (err.response?.status === 401) {
        onLogin();
      } else {
        console.log("failed to post comment: ", err)
      }
    }
  };
  const handleButtonClick = () => {
    handleSubmitComment(newComment, null)
  }
  const handleReply = (commentId, indexMap) => {
    if (!user) {
      onLogin();
      return;
    }
    expandedComments[commentId] = true
    setExpandedComments({ ...expandedComments })
  }
  const updateComment = (index) => (comment) => {
    review.comments[index] = comment
    updateReview({ ...review })
  }
  return (
    <div>
      {review.comments && review.comments.length && (
        <div className="card-footer">
          <div className="comment-length" onClick={toggleComment}>{review.comments.length} comment{review.comments.length > 1 ? 's' : ''}</div>
        </div>)}
      <div className="card-footer" style={{ padding: '0 0.5rem' }}>
        <div className="card-footer-row">
          <div className="comment-button" onClick={toggleComment}>
            <FaRegComment />
            <div style={{ marginLeft: '0.5rem' }}>Comment</div>
          </div>
        </div>
        {review && showComments && (
          <div>
            <div className="sticky-comment-footer">
              <textarea
                className="sticky-comment-input"
                value={newComment}
                onChange={(e) => {
                  setNewComment(e.target.value);
                  e.target.style.height = 'auto';
                  e.target.style.height = Math.min(e.target.scrollHeight, 150) + 'px';
                }}
                onFocus={(e) => {
                  e.target.style.height = 'auto';
                  e.target.style.height = Math.min(e.target.scrollHeight, 150) + 'px';
                }}
                onBlur={(e) => {
                  e.target.style.height = '36px';
                }}
                placeholder={
                  !user
                    ? "Log in to post a comment"
                    : "Write your reply here..."
                }
                disabled={!user}
                onKeyPress={(e) => {
                  if (e.key === 'Enter' && !e.shiftKey) {
                    e.preventDefault();
                    if (!newComment) {
                      return
                    }
                    handleSubmitComment(newComment, null);
                  }
                }}
                rows="1"
              />
              {!!user ? (
                <button
                  style={{ marginLeft: '0.5rem' }}
                  className="sticky-comment-button"
                  onClick={handleButtonClick}
                  disabled={!newComment.trim()}
                  title={"Send reply"}
                >
                  <FaPaperPlane />
                </button>
              ) : (
                <button
                  className="sticky-comment-button"
                  onClick={onLogin}
                >
                  Log in
                </button>
              )}
            </div>
            <div className="comments-list" style={{overflowY:'scroll'}}>
              {review.comments && review.comments.length && review.comments.map((comment, index) => (
                <Comment
                  key={comment.id}
                  comment={comment}
                  onReply={handleReply}
                  isLast={false}
                  isRoot={true}
                  expandedComments={expandedComments}
                  setExpandedComments={setExpandedComments}
                  newComment={newComment}
                  setNewComment={setNewComment}
                  handleSubmitComment={handleSubmitComment}
                  user={user}
                />
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default FeedCardFooter;